import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const Gallery = Styled.div`
max-height: 50rem;
display: grid;
max-width: 52rem;
grid-template-columns: repeat(2, 1fr);
grid-gap: 2rem;
@media only screen and (max-width: 700px){grid-template-columns: repeat(1, 1fr);
  max-height: 100%;
};
`;

const Thumbnail = Styled.article`
position: relative;
background-color:transparent;
img {height: 100%; width: 100%; object-fit: cover;};
border-radius: 5px;
overflow:hidden;
`;

const FloatingText = Styled.p`
color:${color.white};
position: absolute;
bottom:20px;
left:20px;
font-weight: bold;
`;

const ThumbnailGallery = ({ images }) => {
  return (
    <Gallery>
      {images.map((image) => (
        <Thumbnail key={image.label}>
          <img src={image.img} alt={image.label} />
          <FloatingText>{image.label}</FloatingText>
        </Thumbnail>
      ))}
    </Gallery>
  );
};

export default ThumbnailGallery;
